import React from 'react'

export const EinfamilienhausIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlSpace='preserve'
      width='100px'
      height='100px'
      version='1.1'
      style={{
        shapeRendering: 'geometricPrecision',
        textRendering: 'geometricPrecision',
        imageRendering: 'optimizeQuality',
        fillRule: 'evenodd',
        clipRule: 'evenodd'
      }}
      viewBox='0 0 642 642'
      xmlnsXlink='http://www.w3.org/1999/xlink'>
      <defs></defs>
      <g id='Layer_x0020_1'>
        <metadata id='CorelCorpID_0Corel-Layer' />
        <rect fill='none' width='642' height='642' />
        <g id='_2483459709360'>
          <path
            fill='black'
            d='M321 81l-244 141 0 144 193 0 0 65 -193 0 0 140 307 0 0 65 -372 0 0 -2c0,-159 0,-290 0,-448l0 -1 309 -179 309 179 0 75 -309 -179z'
          />
          <polygon
            fill='#5e6371'
            points='384,370 565,370 565,283 630,321 630,636 565,636 565,435 384,435 384,522 319,522 319,141 384,179 '
          />
        </g>
      </g>
    </svg>
  )
}
